import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { ConvertUtils } from "../../../../../../common/utils/convert";
import { useMemo } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  respondidaPor: string | null;
  data: Date | null;
  local: string | null;
  status: number;
  onRespondidaPorChange: (value: string | null) => void;
  onDataChange: (value: Date | null) => void;
  onLocalChange: (value: string | null) => void;
  onStatusChange: (value: number) => void;
  onClearFilters: () => void;
};

export const Header = ({
  respondidaPor,
  data,
  local,
  status,
  onRespondidaPorChange,
  onDataChange,
  onLocalChange,
  onStatusChange,
  onClearFilters,
}: Props) => {

  const statusOptions = useMemo(() => {
    return [
      { id: 2, label: 'Todas' },
      { id: 0, label: 'Em aberto' },
      { id: 1, label: 'Finalizadas' },
    ];
  }, [
  ]);

  return (
    <CascateList title='Filtros' defaultOpen={true}>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
          <DefaultInput
            name='respondidaPor'
            label='Respondida Por'
            value={respondidaPor}
            onChangeValue={e => onRespondidaPorChange(e)}
          />

          <DefaultDatePickerInput
            label='Data'
            value={data}
            onChange={e => onDataChange(e)}
          />

          <DefaultInput
            name='local'
            label='Local'
            value={local}
            onChangeValue={e => onLocalChange(e)}
          />

          <DefaultSelectInput
            name='status'
            label='Status'
            showSelectionLabel={false}
            options={statusOptions}
            value={status}
            onChangeValue={e => onStatusChange(ConvertUtils.toNumber(e))}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}